<template>
  <div v-if="asyncDataStatus_ready">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.paymentTypes.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter = ''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({ name: 'MyCompanyPaymentTypesNew' })"
        >
          Nov tip plačila
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.paymentTypes.length">
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Tip plačila
                </th>
                <th class="text-left">
                  Popust %
                </th>
                <th class="text-left">
                  Vrednost
                </th>
                <th class="text-left">
                  Nova vrednost
                </th>
                <th class="text-left">
                  Datum nove vrednosti
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredPaymentTypes" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.discount | price}}</td>
                <td>{{ item.value | price }}</td>
                <td>{{ item.new_value | price }}</td>
                <td>{{ item.start_date | sloDate }}</td>
                <td class="text-right">
                  <ButtonActionEdit
                    @click="
                      $router.push({
                        name: 'MyCompanyPaymentTypesEdit',
                        params: { id: item.id }
                      })
                    "
                  />
                  <ButtonActionDelete
                    @click="
                      showDeletePaymentTypeModal = true;
                      deletePaymentType = item;
                    "
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega tipa plačila uporabite gumb
          desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje tipa plačila"
      text="Ali ste prepričani, da želite izbrisati tip plačila? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeletePaymentTypeModal"
      @confirmed="remove(deletePaymentType)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'

export default {
  components: {
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete
  },
  mixins: [asyncDataStatus],
  data () {
    return {
      filter: '',
      showDeletePaymentTypeModal: false,
      deletePaymentType: null
    }
  },
  computed: {
    paymentTypes () {
      return objectToArray(this.$store.state.paymentTypes.items)
    },
    filteredPaymentTypes () {
      return this.paymentTypes.filter(item =>
        siIncludes({ haystack: `${item.name}`, needle: this.filter })
      )
    }
  },
  methods: {
    ...mapActions('paymentTypes', ['loadItems', 'deleteItem']),
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    loadItems(this)
  }
}
</script>
